import { z } from 'zod/v4'

export const ampApiErrorSchema = z.object({
    code: z.union([z.number(), z.string()]),
    title: z.string(),
    description: z.string(),
})

export type AmpApiError = z.infer<typeof ampApiErrorSchema>
